// import React, { Component } from 'react';
// import Cookies from 'universal-cookie';
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { url,logout } from '../components/helper'
// import { Loader } from 'react-overlay-loader';
// import SelectList from '../components/createQuestionSubComponents/dropdownSelect'
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// class CreateUser extends Component{

//     constructor(props){
//         super(props)
//         this.state={
//             options_organization:[],
//             organization:null,
//             orgs_loaded:false,
//             options_branch: [],
//             branch: null,
//             isSuper:false,
//             isOrg:false,
//             isBranch:false,
//             isBranchView:false,
//             orgAdminSelectionModalOpen:false,
//             branchAdminSelectionModalOpen:false,
//             loading:false,
//             loadingBranches:false,
//             fnameError:false,
//             lnameError:false,
//             emailError:false,
//             usernameError:false,
//             passwordError:false,
//             messageBoxOpen:false,
//             messageTitle:"",
//             messageBody:"",
//             messageType:1
//         }
//         this.HandleOrgAdminSelect = this.HandleOrgAdminSelect.bind(this)
//         this.closeOrgSelectModal = this.closeOrgSelectModal.bind(this)
//         this.handleOrganizationSelectBranch = this.handleOrganizationSelectBranch.bind(this)
//         this.handleOrganizationSelect.bind(this)
//         this.handleBranchSelectSelect.bind(this)
//         this.HandleBranchAdminSelect.bind(this)
//         this.closeBranchSelectModal.bind(this)
//         this.validateFirstName.bind(this)
//         this.validateLastName.bind(this)
//         this.validateEmailName.bind(this)
//         this.validateUsername.bind(this)
//         this.checkpasswords.bind(this)
//         this.closeMessageBox.bind(this)
//         this.create_user.bind(this)
//         this.HandleSuperAdminSelect.bind(this)
//     }

//     componentWillMount = () =>{
//         var cookies = new Cookies();
//         var loginStatus = cookies.get('loggedIn')
//         if (loginStatus === undefined) {
//             window.location = '/login'
//         }
//         var superuser = cookies.get('superuser')
//         if(superuser !== 'true'){
//             window.location = '/dashboard'
//         }

//     }

//     HandleOrgAdminSelect = () =>{
//         this.setState({
//             isSuper:false,
//             isOrg:true,
//             isBranch:false
//         })
//        if(this.state.orgs_loaded === false){
//            //("is zero")
//         this.setState({
//             loading:true
//         })
//         var cookies = new Cookies();
//         var dashboar_ref = this
//         var http = new XMLHttpRequest();
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         http.open('GET', url+'/api/questions/wizard/organisation?user_id=' + user_id, true);
//         http.setRequestHeader("Authorization", "Token " + token);
//         http.send()
//         http.onreadystatechange = function () {
//             //(http.responseText)
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                     if (json.status === 200) {
//                         var orgs = []
//                         json.organisations.forEach(element => {
//                             var temp = {
//                                 value: element.org_name, label: element.org_name, id: element.org_id
//                             }
//                             orgs.push(temp)
//                             //(orgs)
//                         });
//                         dashboar_ref.setState({
//                             options_organization: orgs,
//                             loading:false,
//                             orgAdminSelectionModalOpen:true,
//                             orgs_loaded:true
//                         })
//                     }
//                 }
//     }
//        }
//        else{
//            this.setState({
//                orgAdminSelectionModalOpen:true
//            })
//        }
//     }

//     closeOrgSelectModal = () =>{
//         this.setState({
//             orgAdminSelectionModalOpen:false
//         })
//     }

//     //Form Validation functions

//     validateFirstName = () =>{
//         var input = document.getElementById("firstname").value
//         if(input === ''){
//             this.setState({fnameError:true})
//         }
//         else{
//             this.setState({fnameError:false})
//         }
//     }

//     validateLastName = () =>{
//         var input = document.getElementById("lastname").value
//         if(input === ''){
//             this.setState({lnameError:true})
//         }
//         else{
//             this.setState({lnameError:false})
//         }
//     }

//     validateEmailName = () =>{
//         var emailRegex = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/
//         var input = document.getElementById('email').value
//         var isvalid = emailRegex.test(input)
//         if(isvalid === false){
//             this.setState({
//                 emailError:true
//             })

//         }
//         else{
//             this.setState({
//                 emailError:false
//             })
//         }

//     }

//     validateUsername = () =>{
//         var usernameRegex = /^[a-zA-Z0-9!@#$%^&*().]+$/;
//         var input = document.getElementById('username').value
//         var isvalid = usernameRegex.test(input)
//         if(isvalid === false){
//             this.setState({
//                 usernameError:true
//             })

//         }
//         else{
//             this.setState({
//                 usernameError:false
//             })
//         }

//     }

//     checkpasswords = () =>{
//         var password = document.getElementById("password").value
//         var cpassword = document.getElementById("confirmpassword").value
//        if(cpassword !== ''){
//         if(password !== cpassword){
//             this.setState({
//                 passwordError:true
//             })
//         }
//         else{
//             this.setState({
//                 passwordError:false
//             })
//         }
//        }
//     }

//     handleOrganizationSelectBranch = (organization) => {
//         this.setState({ organization,loadingBranches:true});
//         const cookies = new Cookies();
//             var http = new XMLHttpRequest();
//             var dashboar_ref = this
//             var user_id = cookies.get('user_id')
//             var token = cookies.get('token')
//             //('Token ' + token)
//             http.open('GET', url+'/api/questions/wizard/branch?user_id=' + user_id + '&org_id=' + organization.id, true);
//             http.setRequestHeader("Authorization", "Token " + token);
//             http.send()
//             http.onreadystatechange = function () {
//                 //(http.responseText)
//                 if (http.readyState === 4 && http.status === 200) {
//                     var json = JSON.parse(http.responseText)
//                     if (json.status === 200) {
//                         var branches = []
//                         json.branches.forEach(element => {
//                             var temp = {
//                                 value: element.branch_name, label: element.branch_name, id: element.branch_id
//                             }
//                             branches.push(temp)
//                             //(branches)
//                         });
//                         dashboar_ref.setState({
//                             options_branch: branches,
//                             branch:null,
//                             loadingBranches:false
//                         })
//                     }

//                 }
//     }}

//     handleOrganizationSelect = (organization) => {
//         this.setState({ organization}, this.enable_btn);
//     }

//     handleBranchSelectSelect = (branch) => {
//         this.setState({ branch }, this.enable_btn);

//         //(`Option selected:`, branch);
//     }

//     HandleBranchAdminSelect = () =>{
//         this.setState({
//             isSuper:false,
//             isOrg:false,
//             isBranch:true
//         })
//         if(this.state.orgs_loaded === false){
//             //("is zero")
//          this.setState({
//              loading:true
//          })
//          var cookies = new Cookies();
//          var dashboar_ref = this
//          var http = new XMLHttpRequest();
//          var user_id = cookies.get('user_id')
//          var token = cookies.get('token')
//          http.open('GET', url+'/api/questions/wizard/organisation?user_id=' + user_id, true);
//          http.setRequestHeader("Authorization", "Token " + token);
//          http.send()
//          http.onreadystatechange = function () {
//              //(http.responseText)
//              if (http.readyState === 4 && http.status === 200) {
//                  var json = JSON.parse(http.responseText)
//                      if (json.status === 200) {
//                          var orgs = []
//                          json.organisations.forEach(element => {
//                              var temp = {
//                                  value: element.org_name, label: element.org_name, id: element.org_id
//                              }
//                              orgs.push(temp)
//                              //(orgs)
//                          });
//                          dashboar_ref.setState({
//                              options_organization: orgs,
//                              loading:false,
//                              branchAdminSelectionModalOpen:true,
//                              orgs_loaded:true
//                          })
//                      }
//                  }
//      }
//         }
//         else{
//             this.setState({
//                 branchAdminSelectionModalOpen:true
//             })
//         }
//     }

//     HandleBranchViewSelect = () =>{
//         this.setState({
//             isSuper:false,
//             isOrg:false,
//             isBranch:false,
//             isBranchView:true
//         })
//         if(this.state.orgs_loaded === false){
//             //("is zero")
//          this.setState({
//              loading:true
//          })
//          var cookies = new Cookies();
//          var dashboar_ref = this
//          var http = new XMLHttpRequest();
//          var user_id = cookies.get('user_id')
//          var token = cookies.get('token')
//          http.open('GET', url+'/api/questions/wizard/organisation?user_id=' + user_id, true);
//          http.setRequestHeader("Authorization", "Token " + token);
//          http.send()
//          http.onreadystatechange = function () {
//              //(http.responseText)
//              if (http.readyState === 4 && http.status === 200) {
//                  var json = JSON.parse(http.responseText)
//                      if (json.status === 200) {
//                          var orgs = []
//                          json.organisations.forEach(element => {
//                              var temp = {
//                                  value: element.org_name, label: element.org_name, id: element.org_id
//                              }
//                              orgs.push(temp)
//                              //(orgs)
//                          });
//                          dashboar_ref.setState({
//                              options_organization: orgs,
//                              loading:false,
//                              branchAdminSelectionModalOpen:true,
//                              orgs_loaded:true
//                          })
//                      }
//                  }
//      }
//         }
//         else{
//             this.setState({
//                 branchAdminSelectionModalOpen:true
//             })
//         }
//     }

//     closeBranchSelectModal = () =>{
//         this.setState({
//             branchAdminSelectionModalOpen:false
//         })
//     }

//     HandleSuperAdminSelect = () =>{
//         this.setState({
//             isSuper:true,
//             isOrg:false,
//             isBranch:false
//         })
//     }

//     closeMessageBox = () =>{
//         if(this.state.messageType === 1){
//             this.setState({
//                 messageBoxOpen:false
//             })
//         }
//         if(this.state.messageType === 2){
//             this.setState({
//                 messageBoxOpen:false
//             })
//             this.HandleOrgAdminSelect()
//         }
//         if(this.state.messageType === 3){
//             this.setState({
//                 messageBoxOpen:false
//             })
//             this.HandleBranchAdminSelect()
//         }
//         if(this.state.messageType === 4){
//             this.setState({
//                 messageBoxOpen:false
//             })
//             window.location = "/create-user/"
//         }
//     }

//     create_user = () =>{
//         // //(this.state.fnameError)
//         // //(this.state.lnameError)
//         // //(this.state.emailError)
//         // //(this.state.usernameError)
//         // //(this.state.passwordError)

//         var fname = document.getElementById("firstname").value
//         var lname = document.getElementById("lastname").value
//         var email =document.getElementById("email").value
//         var username = document.getElementById("username").value
//         var password = document.getElementById("password").value
//         var cpassword = document.getElementById("confirmpassword").value

//         if(fname === '' && lname === '' && email === '' && username === '' && password === '' && cpassword === ''){
//             this.setState({
//                 messageTitle:"Empty form",
//                 messageBody:"Please fill in required details",
//                 messageBoxOpen:true,
//                 messageType:1
//             })
//             return
//         }

//         if(this.state.fnameError === true | this.state.lnameError === true | this.state.emailError === true  | this.state.usernameError === true | this.state.passwordError === true | cpassword === ''){
//             this.setState({
//                 messageTitle:"Missing Credentials",
//                 messageBody:"One of the form fields is incorrect. Please input correct data",
//                 messageBoxOpen:true,
//                 messageType:1
//             })
//             return
//         }

//         if(this.state.isSuper === false && this.state.isOrg === false && this.state.isBranch === false
//             && this.state.isBranchView === false
//             ){
//             this.setState({
//                 messageTitle:"User type not seletced",
//                 messageBody:"Please select a user type",
//                 messageBoxOpen:true,
//                 messageType:1
//             })
//             return
//         }

//         if(this.state.isOrg === true && this.state.organization === null){
//             this.setState({
//                 messageTitle:"Organization Missing",
//                 messageBody:"You have selected Organization Admin as user type. Please select organization for user",
//                 messageBoxOpen:true,
//                 messageType:2
//             })
//             return
//         }

//         if(this.state.isBranch === true && this.state.branch === null){
//             this.setState({
//                 messageTitle:"Branch Missing",
//                 messageBody:"You have selected Branch Admin as user type. Please select branch for user",
//                 messageBoxOpen:true,
//                 messageType:3
//             })
//             return
//         }

//         if(this.state.isBranchView === true && this.state.branch === null){
//             this.setState({
//                 messageTitle:"Branch Missing",
//                 messageBody:"You have selected Branch View as user type. Please select branch for user",
//                 messageBoxOpen:true,
//                 messageType:3
//             })
//             return
//         }

//         this.setState({
//             loading:true
//         })
//         var arg_list = '&first_name='+fname+'&last_name='+lname+"&email="+email+'&username='+username+'&password='+password

//         arg_list = this.state.isSuper ? arg_list+'&is_superuser=True' : arg_list
//         arg_list = this.state.isOrg ? arg_list+'&is_organisation_admin=True&org_id='+this.state.organization.id : arg_list
//         arg_list = this.state.isBranch ? arg_list+'&is_branch_admin=True&branch_id='+this.state.branch.id : arg_list
//         arg_list = this.state.isBranchView ? arg_list+'&is_branch_view=True&branch_id='+this.state.branch.id : arg_list

//         //(arg_list)

//         const cookies = new Cookies();
//         var http = new XMLHttpRequest();
//         var dasboard_ref = this
//         var token = cookies.get('token')
//         //('Token ' + token)
//         http.open('POST', url+'/api/user/register', true);
//         http.setRequestHeader("Authorization", "Token " + token);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         http.send(arg_list)
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 //(http.responseText)
//                 if(json.status === 200){
//                     dasboard_ref.setState({
//                         messageTitle:"User Created",
//                         messageBody:"User "+fname+" "+lname+" has been created successfully",
//                         messageBoxOpen:true,
//                         messageType:4,
//                         loading:false
//                     })
//                 }
//                 else{
//                     dasboard_ref.setState({
//                         messageTitle:"Could not create user",
//                         messageBody:"User "+fname+" "+lname+" could not be created",
//                         messageBoxOpen:true,
//                         messageType:1,
//                         loading:false
//                     })
//                 }
//             }
//             if(http.readyState === 4 && http.status === 401){
//                 logout()
//             }

//         }
//         http.onerror = function(){
//             dasboard_ref.setState({
//                 messageTitle:"No response",
//                 messageBody:"Could not contact server",
//                 messageBoxOpen:true,
//                 messageType:1,
//                 loading:false
//             })
//         }
//         http.timeout = function(){
//             dasboard_ref.setState({
//                 messageTitle:"Request Timeout",
//                 messageBody:"Server did not respond in time. Try again",
//                 messageBoxOpen:true,
//                 messageType:1,
//                 loading:false
//             })
//         }

//     }

//     render(){
//         return(
//             <div>
//                 <Loader loading={this.state.loading} fullPage={true} />
//                 <div className="clearfix" id="page-header">
//             <div>
//                 <Header />
//             </div>
//         </div>

//         <div >
//             <SideBar isActive="user"/>
//         </div>
//         <div id="page-content-wrapper" className="rm-transition">
//         <div id="page-content">
//         <Modal isOpen={this.state.messageBoxOpen}>
//             <ModalHeader>{this.state.messageTitle}</ModalHeader>
//             <ModalBody><b>{this.state.messageBody}</b></ModalBody>
//             <ModalFooter><Button color="primary" onClick={this.closeMessageBox}>Close</Button></ModalFooter>
//         </Modal>
//         <Modal isOpen={this.state.orgAdminSelectionModalOpen}>
//         <ModalHeader>Select Organization For User</ModalHeader>
//         <ModalBody>

//             <h3 ><b>Select Organization</b></h3>
//             <SelectList options={this.state.options_organization} actionHandler={this.handleOrganizationSelect} selectedOption={this.state.organization} />

//         </ModalBody>
//         <ModalFooter>
//             <Button color="primary" onClick={this.closeOrgSelectModal}>Done</Button>
//         </ModalFooter>
//         </Modal>

//         <Modal isOpen={this.state.branchAdminSelectionModalOpen}>
//         <ModalHeader>Select Branch For User</ModalHeader>
//         <ModalBody>
//         <Loader loading={this.state.loadingBranches} />
//             <div>
//             <h3 ><b>Select Organization</b></h3>
//             <SelectList options={this.state.options_organization} actionHandler={this.handleOrganizationSelectBranch} selectedOption={this.state.organization} />
//             </div>

//             <div style={{marginTop:30, height:'auto'}}>
//             <h3>Select Branch</h3>
//              <SelectList options={this.state.options_branch} actionHandler={this.handleBranchSelectSelect} selectedOption={this.state.branch} />
//             </div>

//         </ModalBody>
//         <ModalFooter>
//             <Button color="primary" onClick={this.closeBranchSelectModal}>Done</Button>
//         </ModalFooter>
//         </Modal>

//         <div className="row">
//             <div className="col-md-2"></div>
//             <div className="col-md-8">
//             <h2 style={{textAlign:"center"}}>Create User</h2>
//             </div>
//             <div className="col-md-2"></div>
//             </div>

//             <div className="row">
//             <div className="col-md-2"></div>
//             <div className="col-md-8">
//             <form>
//                     <div className="form-group">
//                         <label htmlFor="firstname"><b>First Name</b></label>
//                         <input type="text" className="form-control" id="firstname" placeholder="Enter First Name" onChange={this.validateFirstName}></input>
//                         <div class="isa_error" hidden={!this.state.fnameError} style={{marginTop:5}}>
//                                 <i class="fa fa-times-circle"></i>
//                                 <b>Please provide first name</b>
//                             </div>
//                     </div>

//                     <div className="form-group">

//                         <label ><b>Last Name</b></label>
//                         <input type="text" className="form-control" id="lastname" placeholder="Enter Last Name" onChange={this.validateLastName}></input>
//                         <div class="isa_error" hidden={!this.state.lnameError} style={{marginTop:5}}>
//                                 <i class="fa fa-times-circle"></i>
//                                 <b>Please provide last name</b>
//                             </div>
//                     </div>

//                      {/* <div className="form-group">
//                         <label for="GPSLocation"><b>GPS location</b></label>
//                         <input type="text" className="form-control" id="GPSLocation" placeholder="Enter Branch GPS location"></input>
//                     </div> */}

//                     <div className="form-group">
//                         <label><b>Email</b></label>
//                         <input type="email" className="form-control" id="email" placeholder="Enter Email Address" onBlur={this.validateEmailName}></input>
//                         <div class="isa_error" hidden={!this.state.emailError} style={{marginTop:5}}>
//                                 <i class="fa fa-times-circle"></i>
//                                 <b>Email Address is not valid</b>
//                             </div>
//                     </div>

//                     <div className="form-group">
//                         <label ><b>Username</b></label>
//                         <input type="text" className="form-control" id="username" placeholder="Enter Username" onChange={this.validateUsername}></input>
//                         <div class="isa_error" hidden={!this.state.usernameError} style={{marginTop:5}}>
//                                 <i class="fa fa-times-circle"></i>
//                                 <b>Username is not valid</b>
//                             </div>
//                     </div>

//                     <div className="form-group">
//                         <label ><b>Password</b></label>
//                         <input type="password" className="form-control" id="password" placeholder="Enter Password" onBlur={this.checkpasswords}></input>
//                     </div>

//                     <div className="form-group">
//                         <label ><b>Confirm Password</b></label>
//                         <input type="password" className="form-control" id="confirmpassword" placeholder="Confirm Password" onBlur={this.checkpasswords}></input>
//                         <div class="isa_error" hidden={!this.state.passwordError} style={{marginTop:5}}>
//                                 <i class="fa fa-times-circle"></i>
//                                 <b>Passwords do not match</b>
//                             </div>
//                     </div>

//                     <div className="form-group" style={{marginTop:20}}>
//                         <div className="row" >
//                             <div className="col-md-4">
//                             <input type="radio" name="usertype" className="form-radio" value="superuser" onChange={this.HandleSuperAdminSelect}></input><label className="my-label"><b>Super Admin</b></label>
//                             </div>
//                             <div className="col-md-4">
//                             <input type="radio" name="usertype" value="orgAdmin" className="form-radio" onChange={this.HandleOrgAdminSelect}></input><label className="my-label"><b>Organizational Admin</b></label>
//                             </div>
//                             <div className="col-md-4">
//                             <input type="radio" name="usertype" value="branchAdmin" className="form-radio" onChange={this.HandleBranchAdminSelect}></input><label className="my-label"><b>Branch Admin</b></label>
//                             </div>
//                             <div className="col-md-4">
//                             <input type="radio" name="usertype" value="isBranchView" className="form-radio" onChange={this.HandleBranchViewSelect}></input><label className="my-label"><b>Branch User</b></label>
//                             </div>
//                         </div>
//                     </div>

//                     <button type="button" className="btn btn-block btn-primary" max-width='100%' onClick={this.create_user}>Create User</button>

//                 </form>
//             </div>
//             <div className="col-md-2"></div>
//             </div>
//         </div>
//         </div>
//         </div>
//         )
//     }

// }

// export default CreateUser

import React, { Component } from 'react'
import Cookies from 'universal-cookie'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
import { url, logout } from '../components/helper'
import { Loader } from 'react-overlay-loader'
import SelectList from '../components/createQuestionSubComponents/dropdownSelect'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

const CreateUser = () => {
    const [optionsOrganization, setOptionsOrganization] = React.useState([])
    const [organization, setOrganization] = React.useState(null)
    const [orgsLoaded, setOrgsLoaded] = React.useState(false)
    const [optionsBranch, setOptionsBranch] = React.useState([])
    const [branch, setBranch] = React.useState(null)
    const [isSuper, setIsSuper] = React.useState(false)
    const [isOrg, setIsOrg] = React.useState(false)
    const [isBranch, setIsBranch] = React.useState(false)
    const [isBranchView, setIsBranchView] = React.useState(false)
    const [orgAdminSelectionModalOpen, setOrgAdminSelectionModalOpen] =
        React.useState(false)
    const [branchAdminSelectionModalOpen, setBranchAdminSelectionModalOpen] =
        React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [loadingBranches, setLoadingBranches] = React.useState(false)
    const [fnameError, setFnameError] = React.useState(false)
    const [lnameError, setLnameError] = React.useState(false)
    const [emailError, setEmailError] = React.useState(false)
    const [usernameError, setUsernameError] = React.useState(false)
    const [passwordError, setPasswordError] = React.useState(false)
    const [messageBoxOpen, setMessageBoxOpen] = React.useState(false)
    const [messageTitle, setMessageTitle] = React.useState('')
    const [messageBody, setMessageBody] = React.useState('')
    const [messageType, setMessageType] = React.useState(1)

    const credentialCheck = () => {
        const cookies = new Cookies()
        const loginStatus = cookies.get('loggedIn')
        if (!loginStatus) {
            window.location = '/login'
        }

        const superuser = cookies.get('superuser')
        if (!superuser) {
            window.location = '/dashboard'
        }
    }

    React.useEffect(() => {
        credentialCheck()
    }, [])

    const handleOrgAdminSelect = async () => {
        setIsSuper(false)
        setIsOrg(false)
        setIsBranch(false)

        if (!orgsLoaded) {
            setLoading(true)
        }

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/wizard/organisation?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    let orgs = []
                    data.organisations.forEach((org) => {
                        const orgElem = {
                            value: org.org_name,
                            label: org.org_name,
                            id: org.org_id,
                        }
                        orgs.push(orgElem)
                    })
                    setOptionsOrganization(orgs)
                    setLoading(false)
                    setOrgAdminSelectionModalOpen(true)
                    setOrgsLoaded(true)
                    break
                default:
                    console.error('Invalid data', data)
                    setOrgAdminSelectionModalOpen(true)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setOrgAdminSelectionModalOpen(true)
        }
    }
    const closeOrgSelectModal = () => {
        setOrgAdminSelectionModalOpen(false)
    }

    const validateFirstName = () => {
        const input = document.getElementById('firstname').value
        setFnameError(input === '')
    }
    const validateLastName = () => {
        const input = document.getElementById('lastname').value
        setLnameError(input === '')
    }

    const validateEmailName = () => {
        const emailRegex =
            /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/

        const input = document.getElementById('email').value
        const isValid = emailRegex.test(input)

        setEmailError(!isValid)
    }

    const validateUsername = () => {
        const usernameRegex = /^[a-zA-Z0-9!@#$%^&*().]+$/
        const input = document.getElementById('username').value
        const isValid = usernameRegex.test(input)
        setUsernameError(!isValid)
    }

    const checkpasswords = () => {
        const password = document.getElementById('password').value
        const cpassword = document.getElementById('confirmpassword').value

        setPasswordError(cpassword === '' || password !== cpassword)
    }

    const handleOrganizationSelectBranch = async (organization) => {
        setOrganization(organization)
        setLoadingBranches(true)
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/wizard/branch?user_id=${userId}&org_id=${organization.id}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    let branches = []
                    data.branches.forEach((branch) => {
                        const branchElem = {
                            value: branch.branch_name,
                            label: branch.branch_name,
                            id: branch.branch_id,
                        }
                        branches.push(branchElem)
                    })
                    setOptionsBranch(branches)
                    setBranch(null)
                    setLoadingBranches(false)
                    break
                default:
                    console.error('Invalid data', data)
                    break
            }
        } catch (err) {
            console.error('Error', err)
        }
    }
    const handleOrganizationSelect = (organization) => {
        setOrganization(organization)
        setIsOrg(true)
        enableBtn()
    }

    const handleBranchSelect = (branch) => {
        setBranch(branch)
        enableBtn()
    }

    const handleBranchAdminSelect = async () => {
        setIsSuper(false)
        setIsOrg(false)
        setIsBranch(true)

        setLoading(!orgsLoaded)

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/wizard/organisation?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    let orgs = []
                    data.organisations.forEach((org) => {
                        const orgElem = {
                            value: org.org_name,
                            label: org.org_name,
                            id: org.org_id,
                        }
                        orgs.push(orgElem)
                    })
                    setOptionsOrganization(orgs)
                    setLoading(false)
                    setBranchAdminSelectionModalOpen(true)
                    setOrgsLoaded(true)
                    break
                default:
                    console.error('Invalid data', data)
                    setBranchAdminSelectionModalOpen(true)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setBranchAdminSelectionModalOpen(true)
        }
    }

    const handleBranchViewSelect = async () => {
        setIsSuper(false)
        setIsOrg(false)
        setIsBranch(false)
        setIsBranchView(true)

        setLoading(!orgsLoaded)

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/wizard/organisation?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    let orgs = []
                    data.organisations.forEach((org) => {
                        const orgElem = {
                            value: org.org_name,
                            label: org.org_name,
                            id: org.org_id,
                        }
                        orgs.push(orgElem)
                    })
                    setOptionsOrganization(orgs)
                    setLoading(false)
                    setBranchAdminSelectionModalOpen(true)
                    setOrgsLoaded(true)
                    break
                default:
                    console.error('Invalid data', data)
                    setBranchAdminSelectionModalOpen(true)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setBranchAdminSelectionModalOpen(true)
        }
    }

    const closeBranchSelectModal = () => {
        setBranchAdminSelectionModalOpen(false)
    }

    const handleSuperAdminSelect = () => {
        setIsSuper(true)
        setIsOrg(false)
        setIsBranch(false)
    }

    //PFIX: Should be a cleaner way to do this
    const closeMessageBox = () => {
        setMessageBoxOpen(false)
        switch (messageType) {
            case 2:
                handleOrgAdminSelect()
                break
            case 3:
                handleBranchAdminSelect()
                break
            case 4:
                window.location = '/create-user/'
                break
        }
    }

    //PFIX: Can be broken down into more manageable functions, surely
    const createUser = async () => {
        const fname = document.getElementById('firstname').value
        const lname = document.getElementById('lastname').value
        const email = document.getElementById('email').value
        const username = document.getElementById('username').value
        const password = document.getElementById('password').value
        const cpassword = document.getElementById('confirmpassword').value

        console.log("INPUT", fname, lname, email, username, password, cpassword)
        console.log("ROLE", isSuper, isOrg, isBranch, isBranchView)

        if (
            !fname &&
            !lname &&
            !email &&
            !username &&
            !password &&
            !cpassword
        ) {
            setMessageTitle('Empty form')
            setMessageBody('Please fill in required details')
            setMessageBoxOpen(true)
            setMessageType(1)
            return
        }

        if (
            fnameError |
            lnameError |
            emailError |
            usernameError |
            passwordError |
            (cpassword === '')
        ) {
            setMessageTitle('Missing Credentials')
            setMessageBody(
                'One of the form fields is incorrect. Please input correct data'
            )
            setMessageBoxOpen(true)
            setMessageType(1)
            return
        }

        if (!isSuper && !isOrg && !isBranch && !isBranchView) {
            setMessageTitle('User type not selected')
            setMessageBody('Please select a user type')
            setMessageBoxOpen(true)
            setMessageType(1)
            return
        }

        if (isOrg && !organization) {
            setMessageTitle('Organization Missing')
            setMessageBody(
                'You have selected Organization Admin as user type. Please select organization for user'
            )
            setMessageBoxOpen(true)
            setMessageType(2)
            return
        }

        if (isBranch && !branch) {
            setMessageTitle('Branch Missing')
            setMessageBody(
                'You have selected Branch Admin as user type. Please select branch for user'
            )
            setMessageBoxOpen(true)
            setMessageType(3)
            return
        }

        if (isBranchView && !branch) {
            setMessageTitle('Branch Missing')
            setMessageBody(
                'You have selected Branch View as user type. Please select branch for user'
            )
            setMessageBoxOpen(true)
            setMessageType(3)
            return
        }

        setLoading(true)
        let argList = `&first_name=${fname}&last_name=${lname}&email=${email}&username=${username}&password=${password}`
        argList = isSuper ? `${argList}&is_superuser=True` : argList
        argList = isOrg
            ? `${argList}&is_organisation_admin=True&org_id=${organization.id}`
            : argList
        argList = isBranch
            ? `${argList}&is_branch_admin=True&branch_id=${branch.id}`
            : argList
        argList = isBranchView
            ? `${argList}&is_branch_view=True&branch_id=${branch.id}`
            : argList

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'POST',
            headers: {
                Authorization: `Token ${token}`,
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: argList,
        }

        try {
            const res = await fetch(`${url}/api/user/register`, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setMessageTitle('User Created')
                    setMessageBody(
                        `User ${fname} ${lname} has been created successfully`
                    )
                    setMessageBoxOpen(true)
                    setMessageType(4)
                    setLoading(false)
                    break
                case 401:
                    logout()
                    break
                default:
                    console.error('Invalid data', data)
                    setMessageTitle('Could not create user')
                    setMessageBody(
                        `User ${fname} ${lname} could not be created`
                    )
                    setMessageBoxOpen(true)
                    setMessageType(1)
                    setLoading(false)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setMessageTitle('No response')
            setMessageBody(`Could not contact server`)
            setMessageBoxOpen(true)
            setMessageType(1)
            setLoading(false)
        }
    }

    const enableBtn = () => {}

    return (
        <div>
            <Loader loading={loading} fullPage={true} />
            <div className="clearfix" id="page-header">
                <div>
                    <Header />
                </div>
            </div>

            <div>
                <SideBar isActive="user" />
            </div>
            <div id="page-content-wrapper" className="rm-transition">
                <div id="page-content">
                    <Modal isOpen={messageBoxOpen}>
                        <ModalHeader>{messageTitle}</ModalHeader>
                        <ModalBody>
                            <b>{messageBody}</b>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={closeMessageBox}>
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={orgAdminSelectionModalOpen}>
                        <ModalHeader>Select Organization For User</ModalHeader>
                        <ModalBody>
                            <h3>
                                <b>Select Organization</b>
                            </h3>
                            <SelectList
                                options={optionsOrganization}
                                actionHandler={handleOrganizationSelect}
                                selectedOption={organization}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={closeOrgSelectModal}
                            >
                                Done
                            </Button>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={branchAdminSelectionModalOpen}>
                        <ModalHeader>Select Branch For User</ModalHeader>
                        <ModalBody>
                            <Loader loading={loadingBranches} />
                            <div>
                                <h3>
                                    <b>Select Organization</b>
                                </h3>
                                <SelectList
                                    options={optionsOrganization}
                                    actionHandler={
                                        handleOrganizationSelectBranch
                                    }
                                    selectedOption={organization}
                                />
                            </div>

                            <div style={{ marginTop: 30, height: 'auto' }}>
                                <h3>Select Branch</h3>
                                <SelectList
                                    options={optionsBranch}
                                    actionHandler={handleBranchSelect}
                                    selectedOption={branch}
                                />
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={closeBranchSelectModal}
                            >
                                Done
                            </Button>
                        </ModalFooter>
                    </Modal>

                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            <h2 style={{ textAlign: 'center' }}>Create User</h2>
                        </div>
                        <div className="col-md-2"></div>
                    </div>

                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            <form>
                                <div className="form-group">
                                    <label htmlFor="firstname">
                                        <b>First Name</b>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="firstname"
                                        placeholder="Enter First Name"
                                        onChange={validateFirstName}
                                    ></input>
                                    <div
                                        class="isa_error"
                                        hidden={!fnameError}
                                        style={{ marginTop: 5 }}
                                    >
                                        <i class="fa fa-times-circle"></i>
                                        <b>Please provide first name</b>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <b>Last Name</b>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="lastname"
                                        placeholder="Enter Last Name"
                                        onChange={validateLastName}
                                    ></input>
                                    <div
                                        class="isa_error"
                                        hidden={!lnameError}
                                        style={{ marginTop: 5 }}
                                    >
                                        <i class="fa fa-times-circle"></i>
                                        <b>Please provide last name</b>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <b>Email</b>
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        placeholder="Enter Email Address"
                                        onBlur={validateEmailName}
                                    ></input>
                                    <div
                                        class="isa_error"
                                        hidden={!emailError}
                                        style={{ marginTop: 5 }}
                                    >
                                        <i class="fa fa-times-circle"></i>
                                        <b>Email Address is not valid</b>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <b>Username</b>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="username"
                                        placeholder="Enter Username"
                                        onChange={validateUsername}
                                    ></input>
                                    <div
                                        class="isa_error"
                                        hidden={!usernameError}
                                        style={{ marginTop: 5 }}
                                    >
                                        <i class="fa fa-times-circle"></i>
                                        <b>Username is not valid</b>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <b>Password</b>
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        placeholder="Enter Password"
                                        onBlur={checkpasswords}
                                    ></input>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <b>Confirm Password</b>
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="confirmpassword"
                                        placeholder="Confirm Password"
                                        onBlur={checkpasswords}
                                    ></input>
                                    <div
                                        class="isa_error"
                                        hidden={!passwordError}
                                        style={{ marginTop: 5 }}
                                    >
                                        <i class="fa fa-times-circle"></i>
                                        <b>Passwords do not match</b>
                                    </div>
                                </div>

                                <div
                                    className="form-group"
                                    style={{ marginTop: 20 }}
                                >
                                    <div className="row">
                                        <div className="col-md-4">
                                            <input
                                                type="radio"
                                                name="usertype"
                                                className="form-radio"
                                                value="superuser"
                                                onChange={
                                                    handleSuperAdminSelect
                                                }
                                            ></input>
                                            <label className="my-label">
                                                <b>Super Admin</b>
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="radio"
                                                name="usertype"
                                                value="orgAdmin"
                                                className="form-radio"
                                                onChange={handleOrgAdminSelect}
                                            ></input>
                                            <label className="my-label">
                                                <b>Organizational Admin</b>
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="radio"
                                                name="usertype"
                                                value="branchAdmin"
                                                className="form-radio"
                                                onChange={
                                                    handleBranchAdminSelect
                                                }
                                            ></input>
                                            <label className="my-label">
                                                <b>Branch Admin</b>
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="radio"
                                                name="usertype"
                                                value="isBranchView"
                                                className="form-radio"
                                                onChange={
                                                    handleBranchViewSelect
                                                }
                                            ></input>
                                            <label className="my-label">
                                                <b>Branch User</b>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    className="btn btn-block btn-primary"
                                    max-width="100%"
                                    onClick={createUser}
                                >
                                    Create User
                                </button>
                            </form>
                        </div>
                        <div className="col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateUser

/**
 * Notes:
 * - Require testing and creating user
 * - A lot of things could be broken down and validations could be streamlined
 * - Missing enable btn function
 *
 */



// WEBPACK FOOTER //
// src/Routes/CreateUser.js